import { InputWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Tenant } from '../../types/tenants'
import useStyles from './styles/TenantBasicInfo.styles'

interface TenantBasicInfoProps {
  values: Tenant
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<Tenant>
  touched: FormikTouched<Tenant>
  handleBlur: {
    (e: React.FocusEvent<any, Element>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  isSubmitting: boolean
}

const TenantBasicInfo: React.FC<TenantBasicInfoProps> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting
}) => {
  const classes = useStyles()
  return (
    <div>
      <SectionTitle title={getTranslate('Basic Details')} marginBottom />
      <div className={classes.inputsContainer}>
        <InputWithLabel
          label={getTranslate('Name')}
          placeholder={getTranslate('Enter the tenant Name')}
          autoComplete="off"
          value={values.basicDetails.name}
          name="basicDetails.name"
          id="basicDetails.name"
          onChange={(event) =>
            setFieldValue('basicDetails.name', event.currentTarget.value)
          }
          error={
            (touched.basicDetails?.name && !!errors.basicDetails?.name) ||
            undefined
          }
          helpertext={
            touched.basicDetails?.name
              ? getTranslate(errors.basicDetails?.name || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          label={getTranslate('Host Name')}
          placeholder={getTranslate('Enter the Host name')}
          autoComplete="off"
          value={values.basicDetails.hostName}
          name="basicDetails.hostName"
          id="basicDetails.hostName"
          onChange={(event) =>
            setFieldValue('basicDetails.hostName', event.currentTarget.value)
          }
          error={
            (touched.basicDetails?.hostName &&
              !!errors.basicDetails?.hostName) ||
            undefined
          }
          helpertext={
            touched.basicDetails?.hostName
              ? getTranslate(errors.basicDetails?.hostName || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
        <InputWithLabel
          label={getTranslate('Slogan')}
          placeholder={getTranslate('Enter the Slogan')}
          autoComplete="off"
          value={values.basicDetails.slogan}
          name="basicDetails.slogan"
          id="basicDetails.slogan"
          onChange={(event) =>
            setFieldValue('basicDetails.slogan', event.currentTarget.value)
          }
          error={
            (touched.basicDetails?.slogan && !!errors.basicDetails?.slogan) ||
            undefined
          }
          helpertext={
            touched.basicDetails?.slogan
              ? getTranslate(errors.basicDetails?.slogan || '')
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
        />
      </div>
    </div>
  )
}
export default TenantBasicInfo
